import { render, staticRenderFns } from "./StudentViewUserInfo.vue?vue&type=template&id=4c7150df&"
import script from "./StudentViewUserInfo.vue?vue&type=script&lang=js&"
export * from "./StudentViewUserInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports